import React from "react";

const Courses = () => {
  return (
    <div className="services container py-5">
    <h2 className="text-center text-danger fw-bold">Our Services</h2>
    <div className="row mt-4">
      <div className="col-md-4 col-12">
        <div className="card">
          <img
            src="https://via.placeholder.com/400x200"
            className="card-img-top"
            alt="IIT-JEE Coaching"
          />
          <div className="card-body">
            <h5 className="card-title">IIT-JEE Coaching</h5>
            <p className="card-text">
              Expert coaching to help you crack IIT-JEE with personalized attention.
            </p>
            <button className="btn btn-danger">Learn More</button>
          </div>
        </div>
      </div>
      <div className="col-md-4 col-12">
        <div className="card">
          <img
            src="https://via.placeholder.com/400x200"
            className="card-img-top"
            alt="NEET Coaching"
          />
          <div className="card-body">
            <h5 className="card-title">NEET Coaching</h5>
            <p className="card-text">
              Comprehensive coaching for NEET preparation with expert faculty.
            </p>
            <button className="btn btn-danger">Learn More</button>
          </div>
        </div>
      </div>
      <div className="col-md-4 col-12">
        <div className="card">
          <img
            src="https://via.placeholder.com/400x200"
            className="card-img-top"
            alt="State Board Exams"
          />
          <div className="card-body">
            <h5 className="card-title">State Board Exams</h5>
            <p className="card-text">
              Achieve top scores in your State Board Exams with our specialized coaching.
            </p>
            <button className="btn btn-danger">Learn More</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default Courses;
